import { render } from "./lessonDiscuss.vue?vue&type=template&id=7e2f9974&scoped=true"
import script from "./lessonDiscuss.vue?vue&type=script&lang=js"
export * from "./lessonDiscuss.vue?vue&type=script&lang=js"

import "./lessonDiscuss.vue?vue&type=style&index=0&id=7e2f9974&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e2f9974"]])

export default __exports__